export default __webpack_public_path__ + "static/media/big2.fa23bc54.jpg";